import { Dma, Region, SegmentSelect, GeoInitialStateProps } from 'utils';

export const geoMapInitial: GeoInitialStateProps = {
    permissions: {
        DMA: [
            Dma.ATLANTA_GA,
            Dma.BOSTON_MA,
            Dma.CHICAGO_IL,
            Dma.DALLAS_FT,
            Dma.HOUSTON_TX,
            Dma.LOS_ANGELES_CA,
            Dma.NEW_YORK_NY,
            Dma.PHILADELPHIA_PA,
            Dma.SAN_FRANCISCO_CA,
            Dma.WASHINGTON_DC,
        ],
        REGION: [Region.WEST, Region.MIDWEST, Region.SOUTH, Region.NORTHEAST],
    },
    selection: {
        projection: {
            Segment: SegmentSelect.REGION,
            REGION: [Region.WEST, Region.MIDWEST, Region.SOUTH, Region.NORTHEAST],
            DMA: Dma.NEW_YORK_NY,
        },
        createScenario: {
            Segment: SegmentSelect.REGION,
            REGION: [Region.WEST, Region.MIDWEST, Region.SOUTH, Region.NORTHEAST],
            DMA: Dma.NEW_YORK_NY,
        },
    },
    selectionType: SegmentSelect.REGION,
};
